/**
 * 错误码定义
 * @module constants/errors
 */

// ============================================
// 错误码常量
// ============================================

export const ERROR_CODES = {
  // 通用错误 1000-1999
  /** 未知错误 */
  UNKNOWN_ERROR: 1000,
  /** 网络错误 */
  NETWORK_ERROR: 1001,
  /** 请求超时 */
  TIMEOUT_ERROR: 1002,
  /** 数据解析错误 */
  PARSE_ERROR: 1003,

  // 认证错误 2000-2999
  /** 认证失败 */
  AUTH_FAILED: 2000,
  /** Token 已过期 */
  TOKEN_EXPIRED: 2001,
  /** Token 无效 */
  TOKEN_INVALID: 2002,
  /** 二维码已过期 */
  QR_CODE_EXPIRED: 2003,
  /** 验证码错误 */
  VERIFY_CODE_ERROR: 2004,

  // 业务错误 3000-3999
  /** 积分不足 */
  INSUFFICIENT_POINTS: 3000,
  /** 需要 VIP 权限 */
  VIP_REQUIRED: 3001,
  /** 参数错误 */
  PARAMETER_ERROR: 3002,

  // 服务器错误 5000-5999
  /** 服务器错误 */
  SERVER_ERROR: 5000,
  /** 服务暂时不可用 */
  SERVICE_UNAVAILABLE: 5001
} as const

// ============================================
// 错误消息映射
// ============================================

export const ERROR_MESSAGES: Record<number, string> = {
  // 通用错误
  [ERROR_CODES.UNKNOWN_ERROR]: '未知错误',
  [ERROR_CODES.NETWORK_ERROR]: '网络错误',
  [ERROR_CODES.TIMEOUT_ERROR]: '请求超时',
  [ERROR_CODES.PARSE_ERROR]: '数据解析错误',

  // 认证错误
  [ERROR_CODES.AUTH_FAILED]: '认证失败',
  [ERROR_CODES.TOKEN_EXPIRED]: 'Token 已过期',
  [ERROR_CODES.TOKEN_INVALID]: 'Token 无效',
  [ERROR_CODES.QR_CODE_EXPIRED]: '二维码已过期',
  [ERROR_CODES.VERIFY_CODE_ERROR]: '验证码错误',

  // 业务错误
  [ERROR_CODES.INSUFFICIENT_POINTS]: '积分不足',
  [ERROR_CODES.VIP_REQUIRED]: '需要 VIP 权限',
  [ERROR_CODES.PARAMETER_ERROR]: '参数错误',

  // 服务器错误
  [ERROR_CODES.SERVER_ERROR]: '服务器错误',
  [ERROR_CODES.SERVICE_UNAVAILABLE]: '服务暂时不可用'
}

// ============================================
// QNW SSO 错误码
// ============================================

export const QNW_SSO_ERROR_CODES = {
  CODE_INVALID: 10400,
  CODE_EXPIRED: 10401,
  CODE_CONSUMED: 10402,
  SOURCE_SOFT_ID_MISMATCH: 10403,
  TARGET_SOFT_ID_MISMATCH: 10404,
  REDIRECT_URI_DENIED: 10405,
  PHONE_REQUIRED: 10406,
  USER_FORBIDDEN: 10407,
  AUTH_FAILED: 10408,
  RESPONSE_INVALID: 10409,
  SERVICE_UNAVAILABLE: 10410
} as const

export const QNW_SSO_ERROR_MESSAGES: Record<number, string> = {
  [QNW_SSO_ERROR_CODES.CODE_INVALID]: 'SSO code 无效',
  [QNW_SSO_ERROR_CODES.CODE_EXPIRED]: 'SSO code 已过期',
  [QNW_SSO_ERROR_CODES.CODE_CONSUMED]: 'SSO code 已使用',
  [QNW_SSO_ERROR_CODES.SOURCE_SOFT_ID_MISMATCH]: '来源产品不匹配',
  [QNW_SSO_ERROR_CODES.TARGET_SOFT_ID_MISMATCH]: '目标产品不匹配',
  [QNW_SSO_ERROR_CODES.REDIRECT_URI_DENIED]: '跳转地址未授权',
  [QNW_SSO_ERROR_CODES.PHONE_REQUIRED]: '当前账号未绑定手机号，无法跨主体登录',
  [QNW_SSO_ERROR_CODES.USER_FORBIDDEN]: '账号状态异常',
  [QNW_SSO_ERROR_CODES.AUTH_FAILED]: 'SSO 鉴权失败',
  [QNW_SSO_ERROR_CODES.RESPONSE_INVALID]: 'SSO 响应异常',
  [QNW_SSO_ERROR_CODES.SERVICE_UNAVAILABLE]: 'SSO 服务暂不可用'
}
